module.exports = __webpack_public_path__ + "img/instagramestory1-1.118bb705.jpg";